

































import { Component, Prop, Vue } from "vue-property-decorator";
import VDraggableList from "@/components/VDraggableList.vue";
import VDraggableListItem from "@/components/VDraggableListItem.vue";
import { ProjectFolderDefault } from "@/api/project/project-folder-default-api";
export interface ProjectPropertyKeyItem {
  id: string;
  name: string;
}

/**
 * 現場のプロパティキーのテーブル
 */

@Component({
  components: {
    VDraggableList,
    VDraggableListItem
  }
})
export default class ProjectFolderDefaultTable extends Vue {
  @Prop({ required: true }) items!: ProjectPropertyKeyItem[];
  @Prop({ required: true }) isType!: string;

  fields = [{ key: "name", label: "キー名" }, { key: "actions", label: "" }];

  async deleteItem(id: string) {
    if (!confirm("この項目を削除してもよろしいですか？")) {
      return;
    }
    this.$emit("remove", id);
  }

  sort(keys: ProjectFolderDefault[]) {
    this.$emit("sort", keys);
  }
}
